export function getDistanceLabel(value: number)
{
    return `${value} km`;
}
